import type {FinishedResponseInteractionService, ReloaderService} from 'shared/services';
import type {Document, Volume, VolumeCreationRequest} from 'src/typings';
import type {VolumeDataService} from './volume.data-service';
import {ngAsync} from 'shared/utils/ng-@decorators';
import {isInterruptedActionResponse} from '../../../modals/modal-utils';

/**
 * @ngdoc service
 * @name VolumeService
 * @module uc.record
 *
 * @description
 *
 */
export default class VolumeService {
    public static readonly serviceName = 'volumeService';

    /*@ngInject*/
    constructor(private volumeDataService: VolumeDataService, private reloader: ReloaderService, private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    @ngAsync()
    public async createVolume(document: Document): Promise<void> {
        return this.showResultIgnoringManualInterruptionAndThenReload(
            () => this.volumeDataService.create({document} as VolumeCreationRequest)
        );
    }

    @ngAsync()
    public async editVolume(volume: Volume, document: Document): Promise<void> {
        return this.showResultIgnoringManualInterruptionAndThenReload(
            () => this.volumeDataService.edit({
                        volume,
                        document,
                        volumeNumber: volume.volumeNumber,
                        year: volume.year,
                        issueQuantity: volume.issueQuantity,
                        description: volume.description,
                        periodicity: volume.periodicity,
                        periodicityMultiplier: volume.periodicityMultiplier
                    })
        );
    }


    @ngAsync()
    public async deleteVolume(volume: Volume): Promise<void> {
        return this.showResultIgnoringManualInterruptionAndThenReload(
            () => this.volumeDataService.delete(volume.id)
        );
    }

    private async showResultIgnoringManualInterruptionAndThenReload(callback: () => Promise<any>) {
        try {
            const response = await callback();
            await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(response);
            this.reloader.reload();
        } catch (error) {
            if (!(error.data && isInterruptedActionResponse(error.data))) {
                await this.finishedResponseInteractionService.showFailedResponseInModalWindow(error);
            }
        }
    }
}
